import { render } from "./NewUserFormContainer.vue?vue&type=template&id=ab9cc9be"
import script from "./NewUserFormContainer.vue?vue&type=script&lang=js"
export * from "./NewUserFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__